<template>
  <div class="c-add-tags">
    <Row :gutter="12" class="c-input-box flex-box">
      <div class="input-row" style="flex: 1">
        <Input v-model="inputTagValue" :placeholder="placeholder" @on-keypress="handlePress">
          <span slot="append" class="add-btn" @click="add">添加（回车键）</span>
        </Input>
      </div>
      <Button v-if="isShowSelect" type="primary" @click="labelModel = true" style="margin-right: 0; margin-left: 8px">选择创意标签</Button>
    </Row>
    <Row :gutter="12" class="c-input-box">
      <div v-if="lenState" class="c-tags-content">
        <Tag v-for="(tag, idx) in value" :key="idx" :name="tag" closable @on-close="handleClose">{{ tag }}</Tag>
        <a href="javascript:;" class="g-error-text c-tags-betch" @click="handleClear">清空</a>
      </div>
      <div v-if="err || err1" class="c-tags-err">
        <span v-if="err">单个标签长度应在{{ minLen }}~{{ maxLen }}个字符之间</span>
        <span v-if="err1">标签最多{{ maxTagNum }}个</span>
      </div>
    </Row>
    <!-- 标签组 -->
    <select-label :transfer="true" v-model="labelModel" :open-id="openId" @on-select="importLabelHandler" />
  </div>
</template>
<script>
import { isArray, isEmpty, getByteLen } from '@/common/js/utils'
import SelectLabel from '@/components/select/select-label.vue'
export default {
  name: 'addTags',
  components: { SelectLabel },
  props: {
    value: {
      type: [Array, String],
      default() {
        return []
      }
    },
    openId: {
      type: [Number, String]
    },
    isShowSelect: {
      type: Boolean,
      default() {
        return true
      }
    },
    maxTagNum: {
      type: Number,
      default() {
        return 20
      }
    },
    minLen: {
      type: Number,
      default() {
        return 0
      }
    },
    maxLen: {
      type: Number,
      default() {
        return 20
      }
    }
  },
  computed: {
    lenState() {
      return this.value && this.value.length
    },
    placeholder() {
      return `最多添加${this.maxTagNum}个，每个${this.minLen ? this.minLen + '-' : '最多'}${
        this.maxLen
      }个字符，用空格分隔，1个中文等于两个字符`
    }
  },
  methods: {
    add() {
      if (!this.inputTagValue) {
        this.err = true
        return false
      } else {
        let tags = this.inputTagValue.split(' ')
        tags = tags.filter((ret) => ret)
        const res = new Set([...this.value, ...tags])
        const valid = tags.some((ret) => {
          return this.calLen(ret) > this.maxLen || this.calLen(ret) < this.minLen
        })
        if (valid) {
          this.err = true
          return false
        }
        if ([...res].length > this.maxTagNum) {
          this.err1 = true
          return false
        }
        this.$emit('input', [...res])
        this.inputTagValue = ''
        this.err = null
        this.err1 = null
      }
    },
    calLen(val) {
      let num = 0
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      if (!isEmpty(val)) {
        const values = val.match(regexp)
        num += getByteLen(val)
        if (isArray(values)) {
          values.forEach((ret) => {
            ret.includes('{') && (num -= 2)
          })
        }
      }
      return num
    },
    // 选择创意标签
    importLabelHandler(vals) {
      if (!isArray(vals)) return
      vals = vals.map((ret) => ret.name)
      const res = new Set([...this.value, ...vals])
      if ([...res].length > this.maxTagNum) this.err1 = true
      this.$emit(
        'input',
        [...res].filter((a, i) => i < this.maxTagNum)
      )
    },
    handleClose(e, name) {
      this.$emit('on-close', name)
      this.err = null
      this.err1 = null
      // 直接在内部实现删除，避免在外部组件调用时每个都要去接收一个删除的事件函数 modify by yangyi 20220804
      const newValue = this.value.filter((v) => v !== name)
      this.$emit('input', newValue)
    },
    handleClear() {
      this.$emit('input', [])
      this.err = null
      this.err1 = null
    },
    handlePress(e) {
      if (e.keyCode === 13) this.add()
    }
  },
  data() {
    return {
      err: null,
      err1: null,
      labelModel: null,
      inputTagValue: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-input-box {
  padding: 0 5px;
  position: relative;

  .input-row,
  ::v-deep.ivu-input-group-append {
    padding: 0 !important;
  }

  .add-btn {
    padding: 0 8px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
  }
}

.flex-box {
  display: flex;
}

.c-tags-content {
  padding: 6px 12px;
  border: solid 1px #dee4f5;
  margin-top: 10px;

  .c-tags-betch {
    line-height: 22px;
    white-space: nowrap;
  }
}

.c-tags-err {
  margin-top: 10px;
  font-size: 14px;
  line-height: 28px;
  color: red;

  span {
    display: block;
  }
}

::v-deep .ivu-tag .ivu-tag-text {
  width: auto;
}

::v-deep.ivu-input-group-append {
  cursor: pointer;
}
</style>
